import { get } from 'lodash/fp';

import { MobileComponentSwitch } from '../../mobile/utils/MobileComponentSwitch';

import RomaAuthModal from './RomaAuthModal';
import { AuthSheet } from './splash/AuthSheet';

type OverlayRoute = {
    overlay?: boolean;
};

type OverlayProps =
    | {
          route?: OverlayRoute;
      }
    | OverlayRoute
    | null
    | undefined;

export const RomaAuthContainer = MobileComponentSwitch(RomaAuthModal, AuthSheet);

export const showOverlay = (props: OverlayProps): boolean => {
    const overlayFromProps = get(['route', 'overlay'], props);

    if (overlayFromProps !== undefined) {
        return overlayFromProps;
    }

    return get(['overlay'], props) || false;
};
